webpackJsonp(["pages.sessions.new"],{

/***/ "./pages/sessions/new/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// CONCATENATED MODULE: ./pages/sessions/new/username_validator.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable comma-dangle, consistent-return, class-methods-use-this, arrow-parens, no-param-reassign, max-len */







var debounceTimeoutDuration = 1000;
var invalidInputClass = 'gl-field-error-outline';
var successInputClass = 'gl-field-success-outline';
var unavailableMessageSelector = '.username .validation-error';
var successMessageSelector = '.username .validation-success';
var pendingMessageSelector = '.username .validation-pending';
var invalidMessageSelector = '.username .gl-field-error';

var username_validator_UsernameValidator = function () {
  function UsernameValidator() {
    var _this = this;

    _classCallCheck(this, UsernameValidator);

    this.inputElement = jquery_default()('#new_user_username');
    this.inputDomElement = this.inputElement.get(0);
    this.state = {
      available: false,
      valid: false,
      pending: false,
      empty: true
    };

    var debounceTimeout = underscore_default.a.debounce(function (username) {
      _this.validateUsername(username);
    }, debounceTimeoutDuration);

    this.inputElement.on('keyup.username_check', function () {
      var username = _this.inputElement.val();

      _this.state.valid = _this.inputDomElement.validity.valid;
      _this.state.empty = !username.length;

      if (_this.state.valid) {
        return debounceTimeout(username);
      }

      _this.renderState();
    });

    // Override generic field validation
    this.inputElement.on('invalid', this.interceptInvalid.bind(this));
  }

  _createClass(UsernameValidator, [{
    key: 'renderState',
    value: function renderState() {
      // Clear all state
      this.clearFieldValidationState();

      if (this.state.valid && this.state.available) {
        return this.setSuccessState();
      }

      if (this.state.empty) {
        return this.clearFieldValidationState();
      }

      if (this.state.pending) {
        return this.setPendingState();
      }

      if (!this.state.available) {
        return this.setUnavailableState();
      }

      if (!this.state.valid) {
        return this.setInvalidState();
      }
    }
  }, {
    key: 'interceptInvalid',
    value: function interceptInvalid(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, {
    key: 'validateUsername',
    value: function validateUsername(username) {
      var _this2 = this;

      if (this.state.valid) {
        this.state.pending = true;
        this.state.available = false;
        this.renderState();
        axios_utils["a" /* default */].get(gon.relative_url_root + '/users/' + username + '/exists').then(function (_ref) {
          var data = _ref.data;
          return _this2.setAvailabilityState(data.exists);
        }).catch(function () {
          return Object(flash["a" /* default */])(Object(locale["a" /* __ */])('An error occurred while validating username'));
        });
      }
    }
  }, {
    key: 'setAvailabilityState',
    value: function setAvailabilityState(usernameTaken) {
      if (usernameTaken) {
        this.state.valid = false;
        this.state.available = false;
      } else {
        this.state.available = true;
      }
      this.state.pending = false;
      this.renderState();
    }
  }, {
    key: 'clearFieldValidationState',
    value: function clearFieldValidationState() {
      this.inputElement.siblings('p').hide();

      this.inputElement.removeClass(invalidInputClass).removeClass(successInputClass);
    }
  }, {
    key: 'setUnavailableState',
    value: function setUnavailableState() {
      var $usernameUnavailableMessage = this.inputElement.siblings(unavailableMessageSelector);
      this.inputElement.addClass(invalidInputClass).removeClass(successInputClass);
      $usernameUnavailableMessage.show();
    }
  }, {
    key: 'setSuccessState',
    value: function setSuccessState() {
      var $usernameSuccessMessage = this.inputElement.siblings(successMessageSelector);
      this.inputElement.addClass(successInputClass).removeClass(invalidInputClass);
      $usernameSuccessMessage.show();
    }
  }, {
    key: 'setPendingState',
    value: function setPendingState() {
      var $usernamePendingMessage = jquery_default()(pendingMessageSelector);
      if (this.state.pending) {
        $usernamePendingMessage.show();
      } else {
        $usernamePendingMessage.hide();
      }
    }
  }, {
    key: 'setInvalidState',
    value: function setInvalidState() {
      var $inputErrorMessage = jquery_default()(invalidMessageSelector);
      this.inputElement.addClass(invalidInputClass).removeClass(successInputClass);
      $inputErrorMessage.show();
    }
  }]);

  return UsernameValidator;
}();

/* harmony default export */ var username_validator = (username_validator_UsernameValidator);
// EXTERNAL MODULE: ./lib/utils/accessor.js
var accessor = __webpack_require__("./lib/utils/accessor.js");

// CONCATENATED MODULE: ./pages/sessions/new/signin_tabs_memoizer.js
var signin_tabs_memoizer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function signin_tabs_memoizer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Memorize the last selected tab after reloading a page.
 * Does that setting the current selected tab in the localStorage
 */

var signin_tabs_memoizer_SigninTabsMemoizer = function () {
  function SigninTabsMemoizer() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$currentTabKey = _ref.currentTabKey,
        currentTabKey = _ref$currentTabKey === undefined ? 'current_signin_tab' : _ref$currentTabKey,
        _ref$tabSelector = _ref.tabSelector,
        tabSelector = _ref$tabSelector === undefined ? 'ul.nav-tabs' : _ref$tabSelector;

    signin_tabs_memoizer__classCallCheck(this, SigninTabsMemoizer);

    this.currentTabKey = currentTabKey;
    this.tabSelector = tabSelector;
    this.isLocalStorageAvailable = accessor["a" /* default */].isLocalStorageAccessSafe();
    // sets selected tab if given as hash tag
    if (window.location.hash) {
      this.saveData(window.location.hash);
    }

    this.bootstrap();
  }

  signin_tabs_memoizer__createClass(SigninTabsMemoizer, [{
    key: 'bootstrap',
    value: function bootstrap() {
      var _this = this;

      var tabs = document.querySelectorAll(this.tabSelector);
      if (tabs.length > 0) {
        tabs[0].addEventListener('click', function (e) {
          if (e.target && e.target.nodeName === 'A') {
            var anchorName = e.target.getAttribute('href');
            _this.saveData(anchorName);
          }
        });
      }

      this.showTab();
    }
  }, {
    key: 'showTab',
    value: function showTab() {
      var anchorName = this.readData();
      if (anchorName) {
        var tab = document.querySelector(this.tabSelector + ' a[href="' + anchorName + '"]');
        if (tab) {
          tab.click();
        }
      }
    }
  }, {
    key: 'saveData',
    value: function saveData(val) {
      if (!this.isLocalStorageAvailable) return undefined;

      return window.localStorage.setItem(this.currentTabKey, val);
    }
  }, {
    key: 'readData',
    value: function readData() {
      if (!this.isLocalStorageAvailable) return null;

      return window.localStorage.getItem(this.currentTabKey);
    }
  }]);

  return SigninTabsMemoizer;
}();

/* harmony default export */ var signin_tabs_memoizer = (signin_tabs_memoizer_SigninTabsMemoizer);
// CONCATENATED MODULE: ./pages/sessions/new/oauth_remember_me.js
var oauth_remember_me__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function oauth_remember_me__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * OAuth-based login buttons have a separate "remember me" checkbox.
 *
 * Toggling this checkbox adds/removes a `remember_me` parameter to the
 * login buttons' href, which is passed on to the omniauth callback.
 **/

var oauth_remember_me_OAuthRememberMe = function () {
  function OAuthRememberMe() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    oauth_remember_me__classCallCheck(this, OAuthRememberMe);

    this.container = opts.container || '';
    this.loginLinkSelector = '.oauth-login';
  }

  oauth_remember_me__createClass(OAuthRememberMe, [{
    key: 'bindEvents',
    value: function bindEvents() {
      jquery_default()('#remember_me', this.container).on('click', this.toggleRememberMe);
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'toggleRememberMe',
    value: function toggleRememberMe(event) {
      var rememberMe = jquery_default()(event.target).is(':checked');

      jquery_default()('.oauth-login', this.container).each(function (i, element) {
        var href = jquery_default()(element).attr('href');

        if (rememberMe) {
          jquery_default()(element).attr('href', href + '?remember_me=1');
        } else {
          jquery_default()(element).attr('href', href.replace('?remember_me=1', ''));
        }
      });
    }
  }]);

  return OAuthRememberMe;
}();

/* harmony default export */ var oauth_remember_me = (oauth_remember_me_OAuthRememberMe);
// CONCATENATED MODULE: ./pages/sessions/new/index.js





document.addEventListener('DOMContentLoaded', function () {
  new username_validator(); // eslint-disable-line no-new
  new signin_tabs_memoizer(); // eslint-disable-line no-new
  new oauth_remember_me({ // eslint-disable-line no-new
    container: jquery_default()('.omniauth-container')
  }).bindEvents();
});

/***/ })

},["./pages/sessions/new/index.js"]);


// WEBPACK FOOTER //
// pages.sessions.new.b39e3617a8b76995572f.bundle.js